/**
 * AUTO-GENERATED FILE — Do not edit manually.
 *
 * To regenerate, run from oc-web/:
 *   `nx run enterprise:fetch-ld-flags`
 *   or
 *   `npx tsx packages/enterprise/scripts/fetchLdFlags.ts`
 */

/* biome-ignore-all lint/style/useNamingConvention: auto-generated enum members match LaunchDarkly flag keys */

export namespace OcDarklyFlags {
  export enum BooleanFlag {
    abacAccountablePersonIncludingOffboarded = 'abac-accountable-person-including-offboarded',
    abacAttributePreload = 'abac-attribute-preload',
    abacCheckDescendants = 'abac-check-descendants',
    abacJobApplicationPreload = 'abac-job-application-preload',
    abacManagingSources = 'abac-managing-sources',
    abacVerboseLogging = 'abac-verbose-logging',
    activeWorkerCountSargableDates = 'active-worker-count-sargable-dates',
    activeWorkerCountSingleQuery = 'active-worker-count-single-query',
    activeWorkerCountWithoutIntersect = 'active-worker-count-without-intersect',
    addExpiryCookie = 'add-expiry-cookie',
    aiAssistant = 'ai-assistant',
    allowModificationOfFieldMetadataInRuntime = 'allow-modification-of-field-metadata-in-runtime',
    analyticsDashboards = 'analyticsDashboards',
    applyWorkerIdPrefix = 'apply-worker-id-prefix',
    auditLookupStrategyModifiedField = 'audit-lookup-strategy-modified-field',
    autoResizeAnalyticsDashboard = 'auto-resize-analytics-dashboard',
    backfillJobApplicationCreatedBusinessEventsScheduler = 'backfill-job-application-created-business-events-scheduler',
    batchEngagementManagerFallback = 'batch-engagement-manager-fallback',
    batchEngagementMember = 'batch-engagement-member',
    batchJobFamilyGroupJobFamily = 'batch-job-family-group-job-family',
    batchJobFamilyJobProfile = 'batch-job-family-job-profile',
    batchLoadCustomFieldDefinitionValues = 'batch-load-custom-field-definition-values',
    batchLoadParentCustomObjectDefinition = 'batch-load-parent-custom-object-definition',
    batchOcHolidayScheduleRequests = 'batch-oc-holiday-schedule-requests',
    batchOcWorkScheduleRequests = 'batch-oc-work-schedule-requests',
    batchOrgMembersSortManagers = 'batch-org-members-sort-managers',
    batchOrgMembershipRevisions = 'batch-org-membership-revisions',
    batchOrgMembershipRevisionsV2 = 'batch-org-membership-revisions-v2',
    batchOrgWorkerCount = 'batch-org-worker-count',
    batchTaeEngagementRevisionLookup = 'batch-tae-engagement-revision-lookup',
    businessEvents = 'business-events',
    businessEventsTopicV2 = 'business-events-topic-v2',
    cacheDetailsLogOnMismatch = 'cache-details-log-on-mismatch',
    cacheForceInitialRefresh = 'cache-force-initial-refresh',
    cacheRepopulateOnMismatch = 'cache-repopulate-on-mismatch',
    calculateJobApplicationBudget = 'calculate-job-application-budget',
    calculateWorkPostingBudget = 'calculate-work-posting-budget',
    camundaProcessEngineEnableCmdExceptionLogging = 'camunda-process-engine-enable-cmd-exception-logging',
    changesetCustomFieldsDeltaGuard = 'changeset-custom-fields-delta-guard',
    changesetTaeAppendixSupport = 'changeset-tae-appendix-support',
    clientSupportLinks = 'client-support-links',
    complianceAndRisksWidget = 'compliance-and-risks-widget',
    complianceCertificationManagement = 'compliance-certification-management',
    continueFailedJobApplication = 'continue-failed-job-application',
    contractAlertsSection = 'contract-alerts-section',
    contractApproveChangeTask = 'contract-approve-change-task',
    contractCompanyCostCentreRelationship = 'contract-company-cost-centre-relationship',
    contractCurrencyValidation = 'contract-currency-validation',
    contractDetailsCompany = 'contract-details-company',
    contractHub = 'contract-hub',
    contractSpend = 'contract-spend',
    contractsInTae = 'contracts-in-tae',
    costCenterWithFinancialFieldsGroup = 'cost-center-with-financial-fields-group',
    costsBypassTaeDisabledCheck = 'costs-bypass-tae-disabled-check',
    criteriaMatcherCache = 'criteria-matcher-cache',
    currencyFieldInExpenseCategory = 'currency-field-in-expense-category',
    customFieldDefinitionRequestCacheReuse = 'custom-field-definition-request-cache-reuse',
    customFieldObjectValueImport = 'custom-field-object-value-import',
    customFieldsHaveHierarchicalPermissions = 'custom-fields-have-hierarchical-permissions',
    customManagingSourceIcons = 'custom-managing-source-icons',
    customizeStandardReport = 'customize-standard-report',
    dailyBriefing = 'daily-briefing',
    dataConnectorExtracts = 'dataConnectorExtracts',
    dateEffectiveEngagementUpdates = 'date-effective-engagement-updates',
    defaultActiveUsers = 'default-active-users',
    deleteDocumentsMissingInCustomFields = 'delete-documents-missing-in-custom-fields',
    demographicInfoTask = 'demographic-info-task',
    devTools = 'dev-tools',
    disableTutorials = 'disable-tutorials',
    documentsAntivirusScan = 'documents-antivirus-scan',
    downloadWorkdaySnapshot = 'download-workday-snapshot',
    duplicateSearch = 'duplicate-search',
    dynamicAnalyticsConfig = 'dynamic-analytics-config',
    engagementBatchLoaderGrouping = 'engagement-batch-loader-grouping',
    engagementBudget = 'engagement-budget',
    engagementBudgetChangesetAware = 'engagement-budget-changeset-aware',
    engagementBudgetChangesetRevision = 'engagement-budget-changeset-revision',
    engagementCacheOrgUidPopulate = 'engagement-cache-org-uid-populate',
    engagementCacheOrgUidUse = 'engagement-cache-org-uid-use',
    engagementDuplicateCheck = 'engagement-duplicate-check',
    engagementRatesFromOc = 'engagement-rates-from-oc',
    engagementSpend = 'engagement-spend',
    enterpriseProjectTasks = 'enterprise-project-tasks',
    enterpriseProjects = 'enterprise-projects',
    erUnificationWorkers = 'er-unification-workers',
    exceptionDebuggingEndpoint = 'exception-debugging-endpoint',
    expenseAttributesStrategyImprovement = 'expense-attributes-strategy-improvement',
    expenseIndexEngagementSupplierSupport = 'expense-index-engagement-supplier-support',
    expenses = 'expenses',
    exportRateCards = 'export-rate-cards',
    extendJobFamilyGroup = 'extend-job-family-group',
    extendedTimesheetExportNotifications = 'extended-timesheet-export-notifications',
    externalIntegrations = 'external-integrations',
    fieldConstraintContractMilestone = 'field-constraint-contract-milestone',
    financeFields = 'finance-fields',
    financeJournalConfig = 'financeJournalConfig',
    fixRatesChangeHistoryInApprovalTask = 'fix-rates-change-history-in-approval-task',
    geocodingMapboxV6 = 'geocoding-mapbox-v6',
    granularReportScheduleIntervals = 'granular-report-schedule-intervals',
    hideAddJobPostingButton = 'hide-add-job-posting-button',
    hideDeprecatedRates = 'hide-deprecated-rates',
    hideInvoicePayments = 'hide-invoice-payments',
    hideNotImplementedRateFrequencies = 'hide-not-implemented-rate-frequencies',
    imageResizer = 'image-resizer',
    importEngagementAppendixFields = 'import-engagement-appendix-fields',
    importMilestoneCustomFields = 'import-milestone-custom-fields',
    importerEngagementRetroChangesValidation = 'importer-engagement-retro-changes-validation',
    includeInvoiceLineItems = 'include-invoice-line-items',
    interviewScheduling = 'interview-scheduling',
    invoiceImportSemanticVersionValidationShared = 'invoice-import-semantic-version-validation-shared',
    invoicePerformanceImprovements = 'invoice-performance-improvements',
    invoicingHtmlTemplate = 'invoicing-html-template',
    jobApplicationDuplicateCheck = 'job-application-duplicate-check',
    jobApplicationStageBatchLoad = 'job-application-stage-batch-load',
    jobApplicationToEngagementLink = 'job-application-to-engagement-link',
    jobPostingBusinessReason = 'job-posting-business-reason',
    jobPostingPauseResumeBusinessEvents = 'job-posting-pause-resume-business-events',
    jobPostingSeniority = 'job-posting-seniority',
    jobPostingSupplierGroups = 'job-posting-supplier-groups',
    kafkaEngagementChangeEvents = 'kafka-engagement-change-events',
    languageSwitcher = 'language-switcher',
    lockPolicyRulesLoadingSetupStep = 'lock-policy-rules-loading-setup-step',
    logInvoiceLineItemIdHashInputs = 'log-invoice-line-item-id-hash-inputs',
    mazeSnippet = 'maze-snippet',
    mediaAntivirusScans = 'media-antivirus-scans',
    memoizeEngagementRevisionChangesets = 'memoize-engagement-revision-changesets',
    memoizeEngagementRevisionJobProfiles = 'memoize-engagement-revision-job-profiles',
    migrateFinancialFieldsMultivalued = 'migrate-financial-fields-multivalued',
    migrateTimeAndExpensesHubToggle = 'migrate-time-and-expenses-hub-toggle',
    moveHolidayScheduleToOc = 'move-holiday-schedule-to-oc',
    nationalIdLegacySuppressionBehaviour = 'national-id-legacy-suppression-behaviour',
    naturalLanguageReportBuilder = 'natural-language-report-builder',
    newDashboard = 'new-dashboard',
    newSanitizeObjectKeys = 'new-sanitize-object-keys',
    newSmartformEditorUi = 'new-smartform-editor-ui',
    newSupplierProfile = 'new-supplier-profile',
    newUiForGroupedSmartFormComponents = 'new-ui-for-grouped-smart-form-components',
    notificationHubSettings = 'notification-hub-settings',
    ocNotifications = 'oc-notifications',
    openJobPostings = 'open-job-postings',
    orgResolverFindOrgBatching = 'org-resolver-find-org-batching',
    orgTreeProgrammaticCopy = 'org-tree-programmatic-copy',
    orgTreeTrimUnusedFields = 'org-tree-trim-unused-fields',
    patchOnlyChangedValuesInWorkerProfile = 'patch-only-changed-values-in-worker-profile',
    peopleSearchByDeprecatedUtmost = 'people-search-by-deprecated-utmost',
    performDuplicateCheckReportUrlRewrite = 'perform-duplicate-check-report-url-rewrite',
    performEngagementRatesMigration = 'perform-engagement-rates-migration',
    personNotifyGwgSelfUpdate = 'person-notify-gwg-self-update',
    postgreSqlAnyConstructQueries = 'postgre-sql-any-construct-queries',
    postgresArrayAnySearchInstrumentation = 'postgres-array-any-search-instrumentation',
    prefetchOrgMembersSortPeople = 'prefetch-org-members-sort-people',
    preloadCustomObjectFieldValues = 'preload-custom-object-field-values',
    preloadPeopleJobProfiles = 'preload-people-job-profiles',
    preloadPeopleManagedOrgs = 'preload-people-managed-orgs',
    preloadPeopleManagers = 'preload-people-managers',
    preloadPeopleOrgMemberships = 'preload-people-org-memberships',
    preloadPersonAndEngagementFields = 'preload-person-and-engagement-fields',
    preloadRevisionReferenceData = 'preload-revision-reference-data',
    preloadWorkerEngagementFields = 'preload-worker-engagement-fields',
    processTriggerOutbox = 'process-trigger-outbox',
    projectCustomFieldMappingsInFlow = 'project-custom-field-mappings-in-flow',
    ratesConfigInOc = 'rates-config-in-oc',
    readinessProbeWaitsForTimesheetIndex = 'readiness-probe-waits-for-timesheet-index',
    readonlySmartformTasks = 'readonly-smartform-tasks',
    reconcileRecentItems = 'reconcile-recent-items',
    removeCandidateApproveRejectButton = 'remove-candidate-approve-reject-button',
    removeOrgMembershipsWhenRemovingEngagement = 'remove-org-memberships-when-removing-engagement',
    reportFinancialFieldFilters = 'report-financial-field-filters',
    reportWorkerQualificationsTemplate = 'report-worker-qualifications-template',
    requestInvoiceUidsForAbac = 'requestInvoiceUidsForAbac',
    requirednessOnFinancialFieldLevel = 'requiredness-on-financial-field-level',
    requireExistenceDetectionFieldsAreUnique = 'requireExistenceDetectionFieldsAreUnique',
    rescindApprovedCandidates = 'rescind-approved-candidates',
    resetEngagementRatesMigration = 'reset-engagement-rates-migration',
    resolveStuckTaskActuator = 'resolve-stuck-task-actuator',
    retryTaeNoResponseException = 'retry-tae-no-response-exception',
    roleAssignmentUserValidation = 'role-assignment-user-validation',
    roleBasedAccessForAnalytics = 'role-based-access-for-analytics',
    rolePeopleBatchLoad = 'role-people-batch-load',
    runHistoricalReport = 'run-historical-report',
    scalableAnomalies = 'scalable-anomalies',
    scheduleReassignTasks = 'schedule-reassign-tasks',
    showJobProfileCreationOption = 'show-job-profile-creation-option',
    sideLoadWorkdayData = 'side-load-workday-data',
    skipInactivePersonsAsTaskAssignees = 'skip-inactive-persons-as-task-assignees',
    skipInactiveUsersAsTaskAssignees = 'skip-inactive-users-as-task-assignees',
    smartformValidationV2 = 'smartform-validation-v-2',
    sourcingConfig = 'sourcing-config',
    sourcingTenantReadinessCheck = 'sourcing-tenant-readiness-check',
    stableAllocationKeyHashcode = 'stable-allocation-key-hashcode',
    strongPasswordPolicy = 'strongPasswordPolicy',
    subProcessStartEventDefinitionScanner = 'sub-process-start-event-definition-scanner',
    suggesterAbac = 'suggester-abac',
    suggesterIndexedSearch = 'suggester-indexed-search',
    suggesterSearchLike = 'suggester-search-like',
    suggesterSinglePerson = 'suggester-single-person',
    supplierCandidatePersonUidLookup = 'supplier-candidate-person-uid-lookup',
    supplierPaymentTerms = 'supplier-payment-terms',
    supplierSearchSplitCountQuery = 'supplier-search-split-count-query',
    supportWidget = 'support-widget',
    syncTimerEvents = 'sync-timer-events',
    synchronize_financial_field_values = 'synchronize_financial_field_values',
    taeEngagementSyncStreaming = 'tae-engagement-sync-streaming',
    taeEntityRevisions = 'tae-entity-revisions',
    taeHubsApprovedDateFilter = 'tae-hubs-approved-date-filter',
    taeHubsDateWindow = 'tae-hubs-date-window',
    taeHubsExpenseTimePeriodFilter = 'tae-hubs-expense-time-period-filter',
    taeHubsLastUpdatedDateFilter = 'tae-hubs-last-updated-date-filter',
    taeInvoiceHubImprovements = 'tae-invoice-hub-improvements',
    taeValidationForTimesheetCorrectionImport = 'tae-validation-for-timesheet-correction-import',
    taskAssignmentAnchoredOnProcessEntity = 'task-assignment-anchored-on-process-entity',
    taskListWorkerName = 'task-list-worker-name',
    teamsNotification = 'teams-notification',
    tenantFeatureStructureValidation = 'tenant-feature-structure-validation',
    testFeatureKey = 'test-feature-key',
    testingSentryIntegrationWithLD = 'testing-sentry-integration-with-LD',
    textFieldSendsNullForEmptyString = 'text-field-sends-null-for-empty-string',
    timeAndExpenseAuditReports = 'time-and-expense-audit-reports',
    timesheetAndExpensesHub = 'timesheet-and-expenses-hub',
    timesheetImportCostCenterFromEngagement = 'timesheet-import-cost-center-from-engagement',
    timesheetMultiApproval = 'timesheet-multi-approval',
    timesheetRuleCalculationVerboseLogging = 'timesheet-rule-calculation-verbose-logging',
    timesheetSettingsBusinessSite = 'timesheet-settings-business-site',
    timesheetSourceTimeAllocations = 'timesheet-source-time-allocations',
    timezoneAwareEngagementProcessLaunching = 'timezone-aware-engagement-process-launching',
    totalReportsCountByClassificationDb = 'total-reports-count-by-classification-db',
    trackUnusedGqlFields = 'track-unused-gql-fields',
    triggerHsr = 'trigger-hsr',
    triggerOriginalBudgetRecalculation = 'trigger-original-budget-recalculation',
    triggerUnscheduledHeadcountReport = 'trigger-unscheduled-headcount-report',
    uiNewInvoiceSettingsPage = 'ui-new-invoice-settings-page',
    uiOrgPickerV2 = 'ui-org-picker-v2',
    uiRestrictCurrencies = 'ui-restrict-currencies',
    ukgJobFamilyImportFilter = 'ukg-job-family-import-filter',
    ukgJobProfileImportFilter = 'ukg-job-profile-import-filter',
    ukgLocationImportFilter = 'ukg-location-import-filter',
    ukgManagerHierarchy = 'ukg-manager-hierarchy',
    ukgOrgLevelMapping = 'ukg-org-level-mapping',
    updateCamundaDatabaseSchema = 'update-camunda-database-schema',
    useAllowedOriginPatterns = 'use-allowed-origin-patterns',
    useInlineJooqQuery = 'use-inline-jooq-query',
    userImporter = 'userImporter',
    validateOcRatesCorrectness = 'validate-oc-rates-correctness',
    validateProrationRuleCoverage = 'validate-proration-rule-coverage',
    validateUsingFieldMetadataOnBackend = 'validate-using-field-metadata-on-backend',
    validateWorkHolidayScheduleUpdates = 'validate-work-holiday-schedule-updates',
    workPostingToGwgSupplierRates = 'work-posting-to-gwg-supplier-rates',
    workRequestAssociatedOutcomes = 'work-request-associated-outcomes',
    workScheduleInOc = 'work-schedule-in-oc',
    workdayRequestTokenWithoutIsu = 'workday-request-token-without-isu',
    workdayConfiguration = 'workdayConfiguration',
    workerProfileGlobalId = 'worker-profile-global-id',
    workerRetroactiveChanges = 'worker-retroactive-changes',
    workerSearchIncludeDeactivated = 'worker-search-include-deactivated'
  }

  export enum StringFlag {
    auditLookupStrategy = 'audit-lookup-strategy',
    auditReportCards = 'audit-report-cards',
    SENTRY_SAMPLING_RATE = 'SENTRY_SAMPLING_RATE',
    SENTRY_SAMPLING_RATE_BPE_WEB = 'SENTRY_SAMPLING_RATE_BPE_WEB',
    sentrySamplingRate = 'sentry-sampling-rate'
  }

  export enum NumberFlag {
    flatfileColumnValidationThreshold = 'flatfileColumnValidationThreshold',
    mixpanelSessionRecording = 'mixpanel-session-recording',
    suggesterSimilarityThreshold = 'suggester-similarity-threshold'
  }

  export enum JsonFlag {}
}

export namespace GlobalDarklyFlags {
  export enum BooleanFlag {
    abacAiAssistant = 'abac-ai-assistant',
    blueprintProcessTrigger = 'blueprint-process-trigger',
    bpDocsAiChatbot = 'bp-docs-ai-chatbot',
    bulkTimesheetCorrection = 'bulk-timesheet-correction',
    clockInOutTimesheetRules = 'clock-in-out-timesheet-rules',
    configureWorkerIdPrefixViaSettingsUi = 'configure-worker-id-prefix-via-settings-ui',
    contractAddWorkerPrefill = 'contract-add-worker-prefill',
    costsQueryV3 = 'costs-query-v3',
    createBlueprintSchedule = 'create-blueprint-schedule',
    dailyUnits = 'daily-units',
    dateControlDisableScrollLock = 'date-control-disable-scroll-lock',
    dynamicBatch = 'dynamic-batch',
    enrichTemplatesInEr = 'enrich-templates-in-er',
    erUnificationContracts = 'er-unification-contracts',
    erUnificationInvoices = 'er-unification-invoices',
    erUnificationTimesheets = 'er-unification-timesheets',
    expenseAiParsing = 'expense-ai-parsing',
    expenseMultiApproval = 'expense-multi-approval',
    failBatchBeforeSyncProcessingForTesting = 'fail-batch-before-sync-processing-for-testing',
    failBatchDuringAsyncProcessingForTesting = 'fail-batch-during-async-processing-for-testing',
    failBatchDuringSyncProcessingForTesting = 'fail-batch-during-sync-processing-for-testing',
    financeHeadcountReportsVisible = 'finance-headcount-reports-visible',
    financeInvoiceSnapshot = 'finance-invoice-snapshot',
    financeSnapshotReportsVisible = 'finance-snapshot-reports-visible',
    fixedHeightSmartformDialog = 'fixed-height-smartform-dialog',
    forcedTimesheetMonthlySplitting = 'forced-timesheet-monthly-splitting',
    hideProgramInfoFromSupplierView = 'hide-program-info-from-supplier-view',
    hsrV2 = 'hsr-v2',
    invoicing20 = 'invoicing-2-0',
    invoicingSupplierFileConfig = 'invoicing-supplier-file-config',
    kafkaOnlyExportNotifications = 'kafka-only-export-notifications',
    lineItemClientAndSupplierAmounts = 'line-item-client-and-supplier-amounts',
    milestoneCorrections = 'milestone-corrections',
    monthlyTimesheets = 'monthly-timesheets',
    multipleCostCenters = 'multiple-cost-centers',
    noInitialTotalCount = 'no-initial-total-count',
    onlyNewExportsMitigation = 'only-new-exports-mitigation',
    permissionsAiAssistant = 'permissions-ai-assistant',
    prorationRules = 'proration-rules',
    rejectPendingAndDraftInvoicesForInvoicing20 = 'reject-pending-and-draft-invoices-for-invoicing-2-0',
    remainingHubsExportUnification = 'remaining-hubs-export-unification',
    reportInvoicingTemplate = 'report-invoicing-template',
    requiresActionReasons = 'requires-action-reasons',
    roundInvoiceTotal = 'round-invoice-total',
    roundTimesheetsAndExpensesHalfUp = 'round-timesheets-and-expenses-half-up',
    runFinanceHeadcountReport = 'run-finance-headcount-report',
    scaleDownMitigation = 'scale-down-mitigation',
    sdrFeesSubtotals = 'sdr-fees-subtotals',
    sdrFiltersPermittedRecords = 'sdr-filters-permitted-records',
    sdrMeetsMilestones = 'sdr-meets-milestones',
    sdrSupplierCustomFields = 'sdr-supplier-custom-fields',
    searchByInvoiceId = 'search-by-invoice-id',
    spendAllocation = 'spend-allocation',
    taeCorrectionAutoApproveViaProcess = 'tae-correction-auto-approve-via-process',
    tenantDateFormat = 'tenant-date-format',
    testFeatureFlag = 'test-feature-flag',
    timesheetAttachments = 'timesheet-attachments',
    validateProrationTimeCodeMisconfiguration = 'validate-proration-time-code-misconfiguration',
    validateRoundingHalfUp = 'validate-rounding-half-up'
  }

  export enum StringFlag {}

  export enum NumberFlag {}

  export enum JsonFlag {}
}
